import request from '@/router/axios';

export const getTradeList = (current, size, params) => request({
  url: '/api/blade-system/post/pageTrade1',
  method: 'get',
  params: {
    ...params,
    current,
    size,
  },
})

export const getList = (current, size, params) => request({
  url: '/api/blade-system/post/page',
  method: 'get',
  params: {
    ...params,
    current,
    size,
  },
})

export const getPostList = tenantId => request({
  url: '/api/blade-system/post/select',
  method: 'get',
  params: {
    tenantId,
  },
})

export const getDetail = id => request({
  url: '/api/blade-system/post/detail',
  method: 'get',
  params: {
    id,
  },
})

export const remove = ids => request({
  url: '/api/blade-system/post/remove',
  method: 'post',
  params: {
    ids,
  },
})

export const add = row => request({
  url: '/api/blade-system/post/submit',
  method: 'post',
  data: row,
})

export const update = row => request({
  url: '/api/blade-system/post/submit',
  method: 'post',
  data: row,
})

export const getRoleTree = tenantId => request({
  url: '/api/blade-system/role/tree',
  method: 'get',
  params: {
    tenantId,
  },
})

export const getTenantList = tenantId => request({
  url: '/api/blade-system/tenant/select',
  method: 'get',
  params: {
    tenantId,
  },
})
